import { PureAbility } from "@casl/ability";
import { inject, injectable } from "inversify";
import { Observable } from "rxjs";

import { Ability_DIID } from "./ability.type";

/**
 * Exposes an ability that can be used to check permissions.
 */
@injectable()
export class AbilityService<T extends PureAbility> {
    /**
     * An ability observable that will emit at each change in the rules
     */
    public readonly ability$: Observable<T> = new Observable<T>((observer) => {
        observer.next(this.ability);
        return this.ability.on("updated", () => observer.next(this.ability));
    });

    constructor(
        @inject(Ability_DIID.symbol)
        public readonly ability: T,
    ) {}
}
